import { AppState } from "./";
export const AppInitialState: AppState = {
  /**
   * The title of this jdi_client_app_state.
   */
  title: "JEDI Client App",
  /**
   * The locale of this jdi_client_app_state.
   */
  locale: "",
  /**
   * The breadcrumbTrail of this jdi_client_app_state.
   */
  breadcrumbTrail: [],
  /**
   * Current page changed flag
   */
  pageChanged: false,
  /**
   * Project ID
   */
  pjtId: "",
  /**
   * GOD flag
   */
  isGodMode: false,
  /**
   * Component Project ID
   */
  cpntPjtId: "",
  /**
   * Whether to display a success toast message on initial display
   */
  isShowSuccessToast: false,
};
